module.exports = __webpack_public_path__ + "img/lost-sign.c2222ab7.svg";